// Thin wrapper around GA4 (gtag.js). gtag is only loaded in production, so every call is a no-op elsewhere.
// Monetary values are sent in pounds, excluding VAT and shipping (net door price).

const CURRENCY = "GBP";

const penceToPounds = (pence) => {
    const number = Number(pence ?? 0);
    return Number.isFinite(number) ? Math.round(number) / 100 : 0;
};

const capitalise = (value) => {
    const text = String(value ?? "").trim();
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
};

export const trackEvent = (eventName, params = {}) => {
    try {
        if (typeof window.gtag === "function") {
            window.gtag("event", eventName, params);
        }
    } catch (e) {
        // Analytics must never break the configurator.
    }
};

// Use before a full-page redirect (e.g. to Stripe) so the hit is sent before the page unloads.
export const trackEventBeforeNavigate = (eventName, params = {}, timeoutMs = 1000) =>
    new Promise((resolve) => {
        if (typeof window.gtag !== "function") {
            resolve();
            return;
        }

        let done = false;
        const finish = () => {
            if (!done) {
                done = true;
                resolve();
            }
        };

        setTimeout(finish, timeoutMs);
        try {
            window.gtag("event", eventName, { ...params, event_callback: finish, event_timeout: timeoutMs });
        } catch (e) {
            finish();
        }
    });

// Builds the GA4 ecommerce payload (value, currency, items) from a basket returned by the API.
export const basketEcommerceParams = (basket, type) => {
    const items = Array.isArray(basket?.basket_items) ? basket.basket_items : [];
    const subtotal = penceToPounds(basket?.total_amount);
    const itemPrice = items.length ? Math.round((subtotal / items.length) * 100) / 100 : subtotal;

    return {
        currency: CURRENCY,
        value: subtotal,
        shipping: penceToPounds(basket?.shipping_amount),
        customer_type: type,
        items: items.map((item) => ({
            item_id: item.external_door_style || "door",
            item_name: `${capitalise(item.external_door_style) || "Configured"} Door`,
            item_category: type,
            item_variant: item.width && item.height ? `${item.width}x${item.height}mm` : undefined,
            price: itemPrice,
            quantity: 1,
        })),
    };
};
